module.exports = __webpack_public_path__ + "media/images/emoticons/flair-0553d286e9aa8085152a883c6e54a826.gif";